export function getLocalDateKey(date: Date): string {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
}

export function dateFromDateKey(dateKey: string): Date {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey);

  if (!match) {
    throw new RangeError(`Invalid date key: ${dateKey}`);
  }

  const [, yearValue, monthValue, dayValue] = match;
  const year = Number(yearValue);
  const month = Number(monthValue);
  const day = Number(dayValue);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    throw new RangeError(`Invalid date key: ${dateKey}`);
  }

  return date;
}

export function getDateKeysInRange(
  startDateKey: string,
  endDateKey: string,
): string[] {
  const startDate = dateFromDateKey(startDateKey);
  const endDate = dateFromDateKey(endDateKey);
  const start = Date.UTC(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
  );
  const end = Date.UTC(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
  );

  if (start > end) {
    throw new RangeError('Start date must not be after end date');
  }

  const keys: string[] = [];

  for (let current = start; current <= end; current += 86400000) {
    keys.push(new Date(current).toISOString().slice(0, 10));
  }

  return keys;
}

export function getMonthKeysInRange(
  startDateKey: string,
  endDateKey: string,
): string[] {
  const startDate = dateFromDateKey(startDateKey);
  const endDate = dateFromDateKey(endDateKey);
  const start = Date.UTC(startDate.getFullYear(), startDate.getMonth(), 1);
  const end = Date.UTC(endDate.getFullYear(), endDate.getMonth(), 1);

  if (start > end) {
    throw new RangeError('Start date must not be after end date');
  }

  const keys: string[] = [];

  for (let current = start; current <= end; ) {
    const date = new Date(current);
    keys.push(
      `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`,
    );
    date.setUTCMonth(date.getUTCMonth() + 1);
    current = date.getTime();
  }

  return keys;
}

export function getDateKeyDistance(
  startDateKey: string,
  endDateKey: string,
): number {
  const startDate = dateFromDateKey(startDateKey);
  const endDate = dateFromDateKey(endDateKey);
  const start = Date.UTC(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
  );
  const end = Date.UTC(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
  );

  if (start > end) {
    throw new RangeError('Start date must not be after end date');
  }

  return Math.round((end - start) / 86400000);
}
